import React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import HomeScreen from '../screens/HomeScreen'

const Stack = createStackNavigator()

const AppNavigator = () => {
  return (
    <NavigationContainer
      linking={{
        prefixes: ['dcl://'],
        config: {
          screens: {
            Home: '/',
            Sailing: '/:sailing',
          },
        },
      }}>
      <Stack.Navigator 
        initialRouteName="Home"
        screenOptions={{
          cardStyle: { backgroundColor: '#FAFAFA' },
        }}>
        <Stack.Screen 
          name="Home"
          component={HomeScreen}
          options={{ 
            headerShown: false,
          }}
        />
        <Stack.Screen 
          name="Sailing"
          component={HomeScreen}
          options={{ 
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  )
}

export default AppNavigator